

import { ModuleActionViewEnum }     from "../enums/moduleActionViewEnum";
import { PeriodPartSelectionEnum }  from "../enums/periodPartSelectionEnum";
import { TimeIntervalEnum }         from "../enums/timeIntervalEnum";

import * as appsettings     from "../appsettings";
import * as main            from "../main";
import * as moment          from "moment";
import * as timeinterval    from "../timeinterval";
import * as viewmode        from "../viewmode";


let dateTimeErrorMessageLabel = "";

/*
* Show / Hide Period Selector
**/
function setVisibilityPeriodSelector(): void {
    const timeinterval_value = Number($("#TimeInterval").data("kendoDropDownList").value());

    if (timeinterval_value == TimeIntervalEnum.AskedPeriod) {
        $("#periodSelector").show();
    } else {
        $("#periodSelector").hide();
    }
}


/**
* Initialize
*/
export function initialize(dateTimeErrorMessage: string): void {
    dateTimeErrorMessageLabel = dateTimeErrorMessage;

    main.setHideDiv("errorMessage", false);
    $("#ReportUserSearchButtonLoader").hide();
    $("#ReportUserExportButtonLoader").hide();

    setVisibilityPeriodSelector();
    this.searchAction(null);
}

/**
* onChange for TimeInterval (show / hide periodSelector)
*/
export function onChangeTimeInterval(): void {
    setVisibilityPeriodSelector();
}

/**
* setReallyAvailable
*/
export function setReallyAvailable(id: number, element: HTMLInputElement): void {

    // Do request
    $.ajax({
        type: "GET",
        url: appsettings.getUrl("ReportUser/SetReallyAvailable"),
        data: {
            msgInlogUserId: id,
            value: element.checked,
        },
        success: function () {
        }
    });

}

/**
* Action export (will download excel document according to the selected period)
*/
export function exportAction(e: kendo.ui.ButtonClickEvent): void {
    //stop the browser from following
    e.preventDefault();

    main.setHideDiv("errorMessage", false);

    // Show the waiting indicator
    $("#ReportUserExportButtonLoader").show();

    // get preference / options selected
    const selectedUserId = Number($("#UserId").data("kendoDropDownList").value());
    const selectedInterval = Number($("#TimeInterval").data("kendoDropDownList").value());

    // Get selection period
    let from: string = "";
    let fromDt = timeinterval.getBeginPeriodSelection(selectedInterval, "From");
    if (fromDt != null) {
        from = fromDt.toUTCString();
    }

    let to: string = "";
    let toDt = timeinterval.getEndPeriodSelection(selectedInterval, "To");
    if (toDt != null) {
        to = toDt.toUTCString();
    }

    if (from != "" && to != "") {
        // Download File
        $.fileDownload(appsettings.getLocalUrl('ReportUser/Export?userId=' + selectedUserId + "&from=" + from + "&to=" + to))
            .done(function () { $("#ReportUserExportButtonLoader").hide(); })
            .fail(function () { $("#ReportUserExportButtonLoader").hide(); });
    }
    else {
        // Hide Indicator
        $("#ReportUserExportButtonLoader").hide();

        // make a message
        main.setHideDiv("errorMessage", true);

        var lblError = $("#errorMessageLabel");
        if (lblError != null && lblError != undefined) {
            lblError.text(dateTimeErrorMessageLabel);
        }
    }
}

/**
* Action search (will display certain bar charts according to the selected period)
*/
export function searchAction(): void {
    main.setHideDiv("errorMessage", false);

    // Indicator
    $("#ReportUserSearchButtonLoader").show();

    // get preference / options selected
    const selectedUserId = Number($("#UserId").data("kendoDropDownList").value());
    const selectedInterval = Number($("#TimeInterval").data("kendoDropDownList").value());
    const selectedPeriod = Number($("#PeriodPartSelection").data("kendoDropDownList").value());

    // Get selection period
    let From: string = "";
    let FromDt = timeinterval.getBeginPeriodSelection(selectedInterval, "From");
    if (FromDt != null) {
        From = moment(FromDt.toUTCString()).format("YYYY-MM-DD[T]HH:mm:ss");
    }

    let To: string = "";
    let ToDt = timeinterval.getEndPeriodSelection(selectedInterval, "To");
    if (ToDt != null) {
        To = moment(ToDt.toUTCString()).format("YYYY-MM-DD[T]HH:mm:ss");
    }

    if (From != "" && To != "") {
        // Do request
        $.ajax({
            type: "GET",
            url: appsettings.getUrl("ReportUser/Search"),
            data: {
                UserId: selectedUserId,
                From: From,
                To: To,
                WorkingDay: selectedPeriod == PeriodPartSelectionEnum.FullPeriod ? null : selectedPeriod
            },
            success: function (responseData: string) {
                // Get response
                $("#searchResult").html(responseData);

                // Hide Indicator
                $("#ReportUserSearchButtonLoader").hide();
            }
        });
    }
    else {
        // Hide Indicator
        $("#ReportUserSearchButtonLoader").hide();

        // make a message
        main.setHideDiv("errorMessage", true);

        const lblError = $("#errorMessageLabel");
        if (lblError != null && lblError != undefined) {
            lblError.text(dateTimeErrorMessageLabel);
        }
    }
}

/**
* 
* @param { kendo.ui.GridEvent } e
*/
export function showMessageItem(e: JQuery.Event & { currentTarget: HTMLElement }): void {

    // Prevent default behaviour
    e.preventDefault();

    viewmode.setViewMode(ModuleActionViewEnum.Show);

    const dataItem = this.dataItem($(e.currentTarget).closest("tr")) as { Id: number };

    // Do request
    $.ajax({
        type: "GET",
        url: appsettings.getUrl("ReportUser/MessageDetails"),
        data: {
            messageInLogId: dataItem.Id
        },
        success: function (responseData: string) {
            // Get response
            $("#selectedMessage").html(responseData);
        }
    });
}


export function editMessageItem(e: JQuery.Event & { currentTarget: HTMLElement }): void {

    // Prevent default behaviour
    e.preventDefault();

    viewmode.setViewMode(ModuleActionViewEnum.Edit);

    const dataItem = this.dataItem($(e.currentTarget).closest("tr")) as { Id: number };

    // Do request
    $.ajax({
        type: "GET",
        url: appsettings.getUrl("ReportUser/MessageDetails"),
        data: {
            messageInLogId: dataItem.Id
        },
        success: function (responseData) {
            // Get response
            $("#selectedMessage").html(responseData);
        }
    });
}


export function initializeSearch(): void {
    $("#selectedMessage").hide();
}

/**
* Checks Passwordfield and Pasword2 field have identical values.
* Is called on leaving Password2 field.
*/
export function startChange(): void {
    const start = $("#From").data("kendoDateTimePicker");
    const end = $("#To").data("kendoDateTimePicker");
    let startDate = start.value();
    let endDate = end.value();

    if (startDate) {
        startDate = new Date(startDate);
        startDate.setDate(startDate.getDate());
        end.min(startDate);
    } else if (endDate) {
        start.max(new Date(endDate));
    } else {
        endDate = new Date();
        start.max(endDate);
        end.min(endDate);
    }
}

/**
* Checks Passwordfield and Pasword2 field have identical values.
* Is called on leaving Password2 field.
*/
export function endChange(): void {
    const start = $("#From").data("kendoDateTimePicker");
    const end = $("#To").data("kendoDateTimePicker");
    let endDate = end.value();
    let startDate = start.value();

    if (endDate) {
        endDate = new Date(endDate);
        endDate.setDate(endDate.getDate());
        start.max(endDate);
    } else if (startDate) {
        end.min(new Date(startDate));
    } else {
        endDate = new Date();
        start.max(endDate);
        end.min(endDate);
    }
}
